
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { SEARCH_PODCASTS, SELECTED_PODCAST, SELECTED_SUBSCRIPTION } from '../actions/PodcastsAction';

const initialState = {
    error: null,
    searchKeyword: "",
    selectedPodcast: {},
    selectedSubscription: {},
}

const persistConfig = {
    key: 'podcasts',
    storage,
    whitelist: ['selectedPodcast'], // place to select which state you want to persist
}

const PodcastsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_PODCASTS:
            return {
                ...state,
                searchKeyword: action.data,
            }
        case SELECTED_PODCAST:
            return {
                ...state,
                selectedPodcast: action.data,
            }
        case SELECTED_SUBSCRIPTION:
            return {
                ...state,
                selectedSubscription: action.data,
            }
        default:
            return { ...state };
    }
};

export default persistReducer(persistConfig, PodcastsReducer);